import { useLazyIndexedDBGraphqlQuery } from '@repo/services';
import { FeatureConfigurationFeatureName } from '@repo/utils';
import { useEffect } from 'react';

import {
  getFeatureConfiguration,
  type GetFeatureConfigurationType,
} from '../queries/featureConfiguration';

export const useFetchFeatureConfiguration = ({
  skip = false,
}: {
  skip?: boolean;
} = {}): {
  featureConfiguration: GetFeatureConfigurationType | null;
  isLoading?: boolean;
  fetchFeatureConfiguration: any;
} => {
  const featuresToFetch = Object.values(FeatureConfigurationFeatureName);

  const [fetchFeatureConfiguration, {
    data: featureConfiguration,
    isLoading,
    error,
  }] = useLazyIndexedDBGraphqlQuery<GetFeatureConfigurationType>({
    cacheKey: `featureConfiguration-${featuresToFetch.join(',')}`,
    document: getFeatureConfiguration,
    variables: {
      featureName: featuresToFetch,
    },
  });

  useEffect(() => {
    if (error) { return; }

    if (!skip && !isLoading && !featureConfiguration) {
      fetchFeatureConfiguration({ document: getFeatureConfiguration });
    }
  }, [fetchFeatureConfiguration, skip, featureConfiguration, isLoading, error]);

  return {
    fetchFeatureConfiguration,
    featureConfiguration: featureConfiguration!,
    isLoading,
  };
};
